import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableDistricts from "./TableDistricts";
import s from "../styles.module.css";
import AddIcon from "@mui/icons-material/Add";
import { fetchDistricts, addDistrict } from "../model/districts";
import CustomModal from "../../../shared/components/Modal/CustomModal";

export const Districts = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const districts = useSelector((state) => state.districts.districts);
  const [page, setPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingError, setLoadingError] = useState(null);
  const rowsPerPage = 10;


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    if (token) {
      setLoadingData(true);
      dispatch(fetchDistricts(token))
        .then(() => setLoadingData(false))
        .catch((error) => {
          setLoadingData(false);
          console.log(error);
          setLoadingError(error.message);
        });
    }
  }, [dispatch, token]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };


  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

 
  const handleConfirm = (data) => {
    const sendData = {
      name: data.name,
      district_type_id: Number(data.district_type_id),
    };
    dispatch(addDistrict({ sendData, token: token }));
    handleCloseModal();
  };
  if (loadingData) {
    return (
      <div className="loadingContainer">
        <div className="loader"></div>
      </div>
    );
  }
  if (loadingError) {
    return (
      <div className="errorDataBox">
        <p>{loadingError}</p>
      </div>
    );
  }
  return (
    <div className="container">
      <h1 className="title">Районы</h1>
      <div className={s.addBtn} onClick={handleOpenModal}>
        <AddIcon sx={{ color: "#fff" }} />
        <button>Добавить район</button>
      </div>

      <TableDistricts
        districts={districts}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
      />

      {/* Модалка для добавления района */}
      <CustomModal
        open={isModalOpen}
        onClose={handleCloseModal}
        title="Добавить район"
        fields={[
          {
            name: "name",
            label: "Название района",
            placeholder: "Введите название района",
            validation: { required: "Поле обязательно" },
          },
            {
                name: "district_type_id",
                label: "Тип района",
                type: "select",
                options: districts.map((type) => ({
                    label: type.name, // Центр города, Спальный район и т.д.
                    value: type.ID,   // 1, 2, 3...
                })),
                validation: { required: "Поле обязательно" },
            },
        ]}
        onConfirm={handleConfirm}
        loading={false}
        mode="add"
      />
    </div>
  );
};
